module.exports = __webpack_public_path__ + "static/media/5_5.fbbf16e6.png";